import { render, staticRenderFns } from "./devolucao.vue?vue&type=template&id=220ee746&scoped=true"
import script from "./devolucao.vue?vue&type=script&lang=js"
export * from "./devolucao.vue?vue&type=script&lang=js"
import style0 from "./devolucao.vue?vue&type=style&index=0&id=220ee746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ee746",
  null
  
)

export default component.exports